// TODO: move to global localStorageKey enum after global cookies changes
import { KnowledgeBaseViewStorageKey } from '../modules/knowledgeBase/knowledgeBase.constants';
import {
  CommonPopulationsItemKey,
  StrategicPopulationsItemKey,
  TooltipOpenStorageKey,
} from '../modules/teamIndicators/components/indicatorsTab/indicatorsTab.constants';
import { TrainingsViewStorageKey } from '../modules/trainings/trainings.constants';
import { VideoSpeedStorageKey, VolumeStorageKey } from '../modules/videoPlayer/components/playerPanel/playerPanel.constants';

export const functionalCookies: (userId: number) => string[] = (userId: number): string[] => ([
  'Lng',
  TooltipOpenStorageKey,
  `${StrategicPopulationsItemKey}${userId}`,
  `${CommonPopulationsItemKey}${userId}`,
  VolumeStorageKey,
  VideoSpeedStorageKey,
  KnowledgeBaseViewStorageKey,
  TrainingsViewStorageKey,
]);
